var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "side" },
    [
      _c(
        "router-link",
        {
          staticClass: "side-content button",
          class: { active: _vm.isActivePath("/agent") },
          attrs: { to: { name: "agent" } },
        },
        [_vm._v(" " + _vm._s(_vm.$t("agentSideMenu.submittedWorks")) + " ")]
      ),
      _c(
        "router-link",
        {
          staticClass: "side-content button",
          class: { active: _vm.isActivePath("/agent/description") },
          attrs: { to: { name: "agentDescription" } },
        },
        [_vm._v(" " + _vm._s(_vm.$t("agentSideMenu.aboutSubmission")) + " ")]
      ),
      _c("CarouselBanner", { staticClass: "carousel-banner" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }